import { auth, functions } from '../firebase'
import { get } from 'lodash'

const userViewedPost = async ({ postId }) => {
  const uid = get(auth, 'currentUser.uid')
  if (uid) {
    // call server function to record the post view
    return functions.userViewedPost({ postId })
  }
}

export default userViewedPost
